"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _UCZW3OGHcjs = require('./UCZW3OGH.cjs');


var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/menubar/menubar-context.tsx
var _react = require('react');
var menubar = _PTOCUU2Dcjs.createStoreContext.call(void 0, 
  [_UCZW3OGHcjs.CompositeContextProvider],
  [_UCZW3OGHcjs.CompositeScopedContextProvider]
);
var useMenubarContext = menubar.useContext;
var useMenubarScopedContext = menubar.useScopedContext;
var useMenubarProviderContext = menubar.useProviderContext;
var MenubarContextProvider = menubar.ContextProvider;
var MenubarScopedContextProvider = menubar.ScopedContextProvider;
var MenuItemCheckedContext = _react.createContext.call(void 0, 
  void 0
);








exports.useMenubarContext = useMenubarContext; exports.useMenubarScopedContext = useMenubarScopedContext; exports.useMenubarProviderContext = useMenubarProviderContext; exports.MenubarContextProvider = MenubarContextProvider; exports.MenubarScopedContextProvider = MenubarScopedContextProvider; exports.MenuItemCheckedContext = MenuItemCheckedContext;
